import { useEffect, useMemo, useState } from 'react';
import { API } from '~/constants';
import {
    IPluginAgent,
    IPluginApplet,
    IPluginTrigger,
    IPluginTriggerFee,
    PLUGIN_FN_PAYMENT_TYPE
} from '@fx-ui/open-sdk';
import { concat, find, map, post } from '~/utils';
import Intl from '@fx-ui/intl';

interface IStorePluginDetail {
    plugin: IPluginAgent;
    applet_list: IPluginApplet[];
    trigger_list: IPluginTrigger[];
}

const FREE_PAYMENT = { type: PLUGIN_FN_PAYMENT_TYPE.FREE as const };

/**
 *  使用 /store/plugin/detail 组装插件函数付费方案
 * @param pluginId 插件的**市场id**
 */
const usePluginFnFee = (pluginId?: string, triggerFees?: IPluginTriggerFee[]) => {
    const [pluginDetail, setPluginDetail] = useState<IStorePluginDetail>();

    useEffect(() => {
        if (!pluginId) {
            return;
        }
        post<IStorePluginDetail>(API.open.store.plugin_detail, { plugin_id: pluginId }).then(
            (res) => {
                setPluginDetail(res.data);
            }
        );
    }, [pluginId]);

    const fnFeeList = useMemo<(IPluginTriggerFee & { name: string; type: string })[]>(() => {
        if (!pluginDetail) {
            return [];
        }
        const appletFees = map(pluginDetail.applet_list, ({ symbol, name }) => {
            return {
                payment: FREE_PAYMENT,
                name,
                symbol,
                type: Intl.get('private.plugin.fronted')
            };
        });
        const triggers = map(pluginDetail.trigger_list, ({ name, symbol }) => {
            const feeItem = find(triggerFees, (fee) => symbol === fee.symbol);
            return {
                name,
                symbol,
                // 不存在于trigger_fee中的后端函数为免费
                payment: feeItem ? feeItem.payment : FREE_PAYMENT,
                type: Intl.get('private.plugin.backend')
            };
        });
        return concat(appletFees, triggers);
    }, [pluginDetail, triggerFees]);

    return fnFeeList;
};

export default usePluginFnFee;
